import { useCallback } from "react";

export default function useAssetDeleteWorkflow({
  companyApi,
  onAssetDeleted,
  deleteTarget,
  setDeleteTarget,
  setDeleteFeedback,
}) {
  const handleConfirmDelete = useCallback(async () => {
    if (!deleteTarget) return;
    try {
      const result = await companyApi.deleteAsset(deleteTarget.id);
      if (setDeleteFeedback) {
        setDeleteFeedback(result?.status === "delete_requested" ? "Asset deletion requested." : "Asset deleted.");
      }
      if (onAssetDeleted) {
        onAssetDeleted(deleteTarget.id, result);
      }
    } catch {
      if (setDeleteFeedback) {
        setDeleteFeedback("Unable to delete asset.");
      }
    } finally {
      setDeleteTarget(null);
    }
  }, [companyApi, deleteTarget, onAssetDeleted, setDeleteFeedback, setDeleteTarget]);

  return { handleConfirmDelete };
}
